import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { EventCards } from "@/services/TablePage/eventTracer";
import { EventTrace } from "@/api/types/event-tracer";
import BaseListV2 from "@/components-UI/list/BaseListV2.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";

interface Props {
    cards: EventCards;
    event: EventTrace;
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTraceCards',
  props: {
    cards: null,
    event: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    cards: EventCards;
    event: EventTrace;
    isLoading: boolean;
}



const leftCol = computed(() => Object.values(props.cards).filter((card) => card.col === 0));
const rightCol = computed(() => Object.values(props.cards).filter((card) => card.col === 1));

return { __sfc: true,props, leftCol, rightCol, BaseListV2, BaseEditableCard }
}

})